/**
 * Mapa de país (ISO-3166 alpha-2) -> nome em PT + bandeira, para exibição
 * amigável no painel admin (ex.: detalhe do saque).
 */
const PAISES: Record<string, { nome: string; flag: string }> = {
  ZA: { nome: 'África do Sul', flag: '🇿🇦' },
  DE: { nome: 'Alemanha', flag: '🇩🇪' },
  AR: { nome: 'Argentina', flag: '🇦🇷' },
  AU: { nome: 'Austrália', flag: '🇦🇺' },
  AT: { nome: 'Áustria', flag: '🇦🇹' },
  BE: { nome: 'Bélgica', flag: '🇧🇪' },
  BR: { nome: 'Brasil', flag: '🇧🇷' },
  CA: { nome: 'Canadá', flag: '🇨🇦' },
  CL: { nome: 'Chile', flag: '🇨🇱' },
  CO: { nome: 'Colômbia', flag: '🇨🇴' },
  KR: { nome: 'Coreia do Sul', flag: '🇰🇷' },
  CR: { nome: 'Costa Rica', flag: '🇨🇷' },
  DK: { nome: 'Dinamarca', flag: '🇩🇰' },
  AE: { nome: 'Emirados Árabes Unidos', flag: '🇦🇪' },
  ES: { nome: 'Espanha', flag: '🇪🇸' },
  US: { nome: 'Estados Unidos', flag: '🇺🇸' },
  PH: { nome: 'Filipinas', flag: '🇵🇭' },
  FI: { nome: 'Finlândia', flag: '🇫🇮' },
  FR: { nome: 'França', flag: '🇫🇷' },
  HK: { nome: 'Hong Kong', flag: '🇭🇰' },
  KY: { nome: 'Ilhas Cayman', flag: '🇰🇾' },
  IN: { nome: 'Índia', flag: '🇮🇳' },
  ID: { nome: 'Indonésia', flag: '🇮🇩' },
  IE: { nome: 'Irlanda', flag: '🇮🇪' },
  IL: { nome: 'Israel', flag: '🇮🇱' },
  IT: { nome: 'Itália', flag: '🇮🇹' },
  JP: { nome: 'Japão', flag: '🇯🇵' },
  LU: { nome: 'Luxemburgo', flag: '🇱🇺' },
  MY: { nome: 'Malásia', flag: '🇲🇾' },
  MX: { nome: 'México', flag: '🇲🇽' },
  NG: { nome: 'Nigéria', flag: '🇳🇬' },
  NO: { nome: 'Noruega', flag: '🇳🇴' },
  NZ: { nome: 'Nova Zelândia', flag: '🇳🇿' },
  NL: { nome: 'Países Baixos', flag: '🇳🇱' },
  PA: { nome: 'Panamá', flag: '🇵🇦' },
  PY: { nome: 'Paraguai', flag: '🇵🇾' },
  PE: { nome: 'Peru', flag: '🇵🇪' },
  PL: { nome: 'Polônia', flag: '🇵🇱' },
  PT: { nome: 'Portugal', flag: '🇵🇹' },
  GB: { nome: 'Reino Unido', flag: '🇬🇧' },
  SG: { nome: 'Singapura', flag: '🇸🇬' },
  SE: { nome: 'Suécia', flag: '🇸🇪' },
  CH: { nome: 'Suíça', flag: '🇨🇭' },
  TH: { nome: 'Tailândia', flag: '🇹🇭' },
  CZ: { nome: 'Tchéquia', flag: '🇨🇿' },
  TR: { nome: 'Turquia', flag: '🇹🇷' },
  UY: { nome: 'Uruguai', flag: '🇺🇾' },
};

/**
 * Formata o país para exibição: "🇺🇸 Estados Unidos".
 * Aceita código ISO-2 (mapeado) e, para dados antigos com valor livre
 * (ex.: "United States"), retorna o valor original.
 */
export const formatPais = (valor?: string | null): string => {
  if (!valor) return '—';
  const pais = PAISES[valor.trim().toUpperCase()];
  return pais ? `${pais.flag} ${pais.nome}` : valor;
};
